/* eslint-disable @next/next/no-html-link-for-pages */

//vendors
import { defaultOptions } from '@/vendor/HubspotFormIntegration';

//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';
import {
  HubspotForm,
  HubspotFormTitle,
  HubspotFormDescription,
} from '@/containers/HubspotForm';
import { VideoPlayer } from '@/containers-m/VideoPlayer';

//context containers
import {
  HeroSection,
  FeatureSection,
  BackgroundImageSection,
} from './containers/';

//components
import {
  CenteredWrapper as CenteredContentWrapper,
  ResponsiveImage,
  Title,
  Text,
  ReversedWrapper,
} from '@/components/Grid/Content';

// styles
import {
  SidePanels,
  CustomSidePanels,
  PageWrapper,
  VideoWrapper,
} from './PortDrayage.styles';

const PortDrayage = () => {
  const video_settings = {
    youtube: 'https://www.youtube.com/watch?v=kcRVTRB5tHE?rel=0',
    preview: '/videos/port-drayage/bg_drayage-sg.webm',
    thumb: '/images/port-drayage/sg-video-thumb.png',
  };

  return (
    <>
      <PageWrapper>
        <Navigation />
        <>
          <HeroSection />

          <CustomSidePanels reverse>
            <VideoWrapper>
              <VideoPlayer content={video_settings} />
            </VideoWrapper>
            <ReversedWrapper>
              <Title>
                Balancing people and technology to give the best options for
                your drayage freight
              </Title>
              <Text>
                Whether you want to quote & book online yourself through{' '}
                <a href="https://shipperguide.com/?utm_source=loadsmart-website">
                  ShipperGuide TMS
                </a>
                , or through your account manager, Loadsmart works to ensure you
                have control and visibility from quoting to settlement.
              </Text>
            </ReversedWrapper>
          </CustomSidePanels>

          <HubspotForm {...defaultOptions}>
            <HubspotFormTitle>Ready to learn more?</HubspotFormTitle>
            <HubspotFormDescription>
              Fill out the form below and a member of the Loadsmart team will be
              in touch.
            </HubspotFormDescription>
          </HubspotForm>

          <FeatureSection />

          <SidePanels>
            <ResponsiveImage
              src={`/images/port-drayage/half_section-smarter_drayage-shipper-guide.png`}
              alt="Smarter Drayage"
            />
            <CenteredContentWrapper>
              <Title>Smart(er) Drayage</Title>
              <Text>
                Our platform connects data from port operators, ELD systems,
                3PLs and WMSs to give you real-time visibility into when a
                container is discharged, available or being held and when a
                truck gates out. This capability also enables us to ensure your
                containers are always returned on-time, avoiding unnecessary
                fees.
              </Text>
            </CenteredContentWrapper>
          </SidePanels>

          <BackgroundImageSection />
        </>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default PortDrayage;
export { PortDrayage };
